import React, { useEffect, useRef, useState } from 'react';
import styles from './../addCategoryForm/addCategoryForm.module.css';
import { Close, Closecircle, closeCircle, UploadImg } from '../../Svg';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { Country, State } from "country-state-city";
import { addCustomerThunk } from '../../redux/customer/customerSlice';
import { addAdminuser, getAllAdminThunk } from '../../redux/admin/adminSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import stylesp from './prod.module.css';


const AddAdminForm = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const { exportCustomerData } = useSelector((state) => state.customer);
    const [isPasswordVisible, setPasswordVisible] = useState(false)
    const [isConfirmPasswordVisible, setConfirmPasswordVisible] = useState(false)


    const [filteredData, setFilteredData] = useState(null);


    const [searchTerm, setSearchTerm] = useState('');
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                closeDropdown();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const closeDropdown = () => {
        setIsOpen(false);
        setSearchTerm('');
        setFilteredData(null);
    };

    const handleToggleDropdown = () => {
        const newState = !isOpen;
        setIsOpen(newState);
        if (!newState) {
            closeDropdown();
        }
    };

    const handleSearchChange = (e) => {
        const term = e.target.value;
        setSearchTerm(term);
        const filtered = term === ''
            ? null
            : exportCustomerData?.filter(customer =>
                (customer?.fullName || '').toLowerCase().includes(term.toLowerCase()) ||
                (customer?.companyName || '').toLowerCase().includes(term.toLowerCase())
            );
        setFilteredData(filtered);
    };



    // Fetch countries on component mount
    useEffect(() => {
        const countryList = Country.getAllCountries();
        setCountries(countryList);
        dispatch(getAllAdminThunk())
    }, []);



    // Define the Formik schema
    const {
        errors,
        values,
        handleChange,
        touched,
        setFieldValue,
        isSubmitting,
        handleBlur,
        handleSubmit,
        resetForm
    } = useFormik({
        initialValues: {
            name: "",
            phone: "",
            email: "",
            password: "",
            confirmPassword: "",
            address: {
                city: "",
                state: "",
                country: "",
            },
            status: "",
            customer: []
        },
        enableReinitialize: true,
        validationSchema: Yup.object({
            name: Yup.string().required('Name is required'),
            phone: Yup.string().required('Phone number is required'),
            email: Yup.string().email('Invalid email').required('Email is required'),
            password: Yup.string().required('Password is required'),
            confirmPassword: Yup.string()
                .oneOf([Yup.ref('password'), null], 'Passwords must match')
                .required('Confirm password is required'),
            status: Yup.string().required('status is required'),

        }),

        onSubmit: async (values) => {

            console.log(values);

            const status = await dispatch(addAdminuser(values))
            console.log(status);

            if (status.payload === 200) {
                navigate(-1)
            }
        },
    });



    // Update states when a country is selected
    const handleCountryChange = (field, countryName) => {
        const selectedCountry = countries.find((country) => country.name === countryName);
        if (selectedCountry) {
            const stateList = State.getStatesOfCountry(selectedCountry.isoCode);
            setStates(stateList);
            setFieldValue(field, countryName); // Set country name
            setFieldValue(field.replace("country", "state"), ""); // Reset state
        }
    };




    // Handle selection change (Add or remove manufacturer)
    const handleSelectionChange = (customerid) => {
        const { customer } = values;
        if (customer?.includes(customerid)) {
            setFieldValue(
                "customer",
                customer?.filter(id => id !== customerid)
            );
        } else {
            setFieldValue(
                "customer",
                [...customer, customerid]
            );
        }
    };
    return (
        <>
            <form onSubmit={handleSubmit} className={styles.updateCategoryContainer}>
                <div className={styles.genaralInfo}>
                    <div className={styles.formSection}>
                        <div className={styles.card}>
                            <h2 className={styles.addCatH2}>General Information</h2>

                            <label className={styles.addCatLabel} >
                                Full name
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Full name"
                                    className={styles.addCatInput}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.name}
                                />
                                {touched.name && errors.name ? (
                                    <div className={styles.errorText}>{errors.name}</div>
                                ) : null}
                            </label>
                            <div style={{ display: 'flex', gap: '14px' }}>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    Phone number
                                    <input
                                        type="phone"
                                        name="phone"
                                        placeholder="Enter"
                                        className={styles.addCatInput}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.phone}
                                    />
                                    {touched.phone && errors.phone ? (
                                        <div className={styles.errorText}>{errors.phone}</div>
                                    ) : null}
                                </label>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    Email id
                                    <input
                                        type="email"
                                        name="email"
                                        autoComplete="off"
                                        placeholder="Enter"
                                        className={styles.addCatInput}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.email}
                                    />
                                    {touched.email && errors.email ? (
                                        <div className={styles.errorText}>{errors.email}</div>
                                    ) : null}
                                </label>
                            </div>
                            <div style={{ display: 'flex', gap: '14px' }}>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    Password
                                    <div className={styles.logininputContainer}>
                                        <input
                                            type="text"
                                            autoComplete="off"
                                            data-lpignore="true"
                                            data-form-type="other"
                                            style={{ WebkitTextSecurity: isPasswordVisible ? 'none' : 'disc' }}
                                            name="password"
                                            placeholder="********"
                                            className={styles.addCatInput}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.password}
                                        />
                                        <FontAwesomeIcon
                                            icon={faEye}
                                            className={styles.loginpasswordIcon}
                                            onClick={() => setPasswordVisible(!isPasswordVisible)}
                                        />
                                    </div>
                                    {touched.password && errors.password ? (
                                        <div className={styles.errorText}>{errors.password}</div>
                                    ) : null}
                                </label>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    Confirm password
                                    <div className={styles.logininputContainer}>
                                        <input
                                            type="text"
                                            autoComplete="off"
                                            data-lpignore="true"
                                            data-form-type="other"
                                            style={{ WebkitTextSecurity: isConfirmPasswordVisible ? 'none' : 'disc' }}
                                            name="confirmPassword"
                                            placeholder="********"
                                            className={styles.addCatInput}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.confirmPassword}
                                        />
                                        <FontAwesomeIcon
                                            icon={faEye}
                                            className={styles.loginpasswordIcon}
                                            onClick={() => setConfirmPasswordVisible(!isConfirmPasswordVisible)}
                                        />
                                    </div>
                                    {touched.confirmPassword && errors.confirmPassword ? (
                                        <div className={styles.errorText}>{errors.confirmPassword}</div>
                                    ) : null}
                                </label>

                            </div>

                            {/* <div style={{ display: "flex", alignItems: "center", gap: '22%', marginTop: "6px" }}>
                                <span style={{
                                    color: "#5A607F",
                                    fontSize: '14px',
                                }}>Account status</span>
                                <FormControlLabel sx={{
                                    margin: '0px',
                                }}
                                    control={
                                        <Switch
                                            checked={isBlocked}
                                            onChange={handleToogle}
                                            sx={{
                                                "& .MuiFormControlLabel-root .MuiFormControlLabel-label": {
                                                    marginTop: "8px",
                                                },
                                                "& .MuiSwitch-switchBase.Mui-checked": {
                                                    color: "#512DA8",
                                                    fontSize: '16px',
                                                    margin: '0px',
                                                },
                                                "& .MuiSwitch-track": {
                                                    padding: '10px 20px',
                                                    borderRadius: '16px'
                                                },
                                                "& .MuiSwitch-thumb": {
                                                    width: "14px",
                                                    height: "14px",
                                                    marginLeft: '6px',
                                                    marginTop: '6px',
                                                },
                                                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                                                    backgroundColor: "#512da8a3",
                                                },
                                            }}
                                        />
                                    }
                                    label="Block"
                                    labelPlacement="end"
                                />
                            </div> */}


                        </div>
                        <div className={styles.card}>
                            <h2 className={styles.addCatH2}>Address</h2>
                            <div style={{ display: 'flex', gap: '14px' }}>
                                <label className={styles.addCatLabel} style={{ width: '100%' }}>
                                    Street, area, city
                                    <input
                                        type="text"
                                        name="address.city"
                                        placeholder="Enter street address"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.address.city}
                                        className={styles.addCatInput}
                                    />

                                </label>

                            </div>
                            <div style={{ display: 'flex', gap: '14px' }}>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    Country
                                    <select
                                        className={styles.addCatSelect}
                                        name="address.country"
                                        value={values.address.country}
                                        onChange={(e) => handleCountryChange("address.country", e.target.value)}
                                        onBlur={handleBlur}
                                    >
                                        <option value="">Select</option>{countries.map((country) => (
                                            <option key={country.isoCode} value={country.name}>
                                                {country.name}
                                            </option>
                                        ))}

                                    </select>

                                </label>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    State
                                    <select
                                        className={styles.addCatSelect}
                                        name="address.state"
                                        value={values.address.state}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    >
                                        <option value="">Select</option>
                                        {states.map((state) => (
                                            <option key={state.isoCode} value={state.name}>
                                                {state.name}
                                            </option>
                                        ))}
                                    </select>

                                </label>
                            </div>
                        </div>
                    </div>
                    <div className={styles.buttonGroup}>
                        <button type="button" className={styles.cancelButton} onClick={() => resetForm()}><Close />Cancel</button>
                        <button type="submit" className={styles.updateButton} disabled={isSubmitting}>{isSubmitting ? 'please wait' : "Save User"}</button>
                    </div>
                </div>

                <div className={styles.thumbnain}>
                    <div className={styles.card}>
                        <h2 className={styles.addCatH2}> Status</h2>
                        <label style={{ paddingBottom: '10px', display: "block" }}>
                            Status
                            <select
                                name="status"
                                className={styles.addCatSelect}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.status}
                            >
                                <option value="">Select...</option>
                                <option value="ACTIVE">Active</option>
                                <option value="INACTIVE">Inactive</option>
                            </select>
                            {touched.status && errors.status && (
                                <div className={styles.errorText}>{errors.status}</div>
                            )}
                        </label>
                    </div>
                    <div className={styles.card}>
                        <h2 className={styles.addCatH2} >   Assign customers</h2>
                        <div style={{ paddingBottom: '10px', display: "block", marginTop: 9 }} className={styles.addCatLabel}>
                            Customers
                            <div style={{ position: 'relative' }} ref={dropdownRef}>

                                <div
                                    className={styles.addCatSelect}
                                    onClick={handleToggleDropdown}
                                >
                                    Select

                                </div>

                                {
                                    isOpen &&
                                    <div className={stylesp.dropdownContent}>
                                         <div style={{}}>
                                            <input
                                                type="text"
                                                placeholder="Search..."
                                                style={{
                                                    width: '100%',
                                                    padding: '10px',
                                                    boxSizing: 'border-box',
                                                    border: '1px solid #ccc',
                                                    borderRadius: '4px'
                                                }}
                                                value={searchTerm}
                                                onChange={handleSearchChange}
                                            />
                                        </div>
                                        <div style={{ maxHeight: "140px", overflowY: "scroll" }}>
                                        {(filteredData || exportCustomerData)?.map((customer) => (
                                           
                                                <label
                                                    key={customer?._id}
                                                    className={stylesp.dropdownItem}
                                                >
                                                    <span style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.25 }}>
                                                        <span style={{ fontWeight: 600 }}>{customer?.companyName || customer?.fullName}</span>
                                                        {customer?.companyName && <span style={{ fontSize: 12, color: '#858D9D' }}>{customer?.fullName}</span>}
                                                    </span>
                                                    <input
                                                        type="checkbox"
                                                        checked={values?.customer?.includes(customer?._id)}
                                                        onChange={() => handleSelectionChange(customer?._id)}
                                                    />
                                                </label>
                                            ))}


                                        </div>
                                        <div style={{ display: 'flex', justifyContent: "center", width: "100%" }}>
                                            <button
                                                type="submit"
                                                className={stylesp.loginButton}
                                                style={{ borderRadius: "0px" }}
                                                onClick={() => setIsOpen(false)}
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                }

                            </div>
                            {values?.customer?.map((i) => {
                                const customer = exportCustomerData.find((item) => item._id === i);
                                return (
                                    <div className={styles.dropdownresult}>
                                        {customer?.companyName ? `${customer.companyName} · ${customer?.fullName || ''}` : customer?.fullName} <div onClick={() => handleSelectionChange(customer._id)}><Closecircle /></div>
                                    </div>
                                )
                            })

                            }
                        </div>
                    </div>
                </div>

            </form>
        </>
    );
};

export default AddAdminForm;












